import React, { useState, useEffect, lazy, Suspense } from 'react';
import { makeStyles, useTheme, withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import {
  Grid,
  IconButton,
  Drawer,
  Box,
  List,
  ListItem,
  ListItemIcon,
  Hidden,
  ListItemText,
} from '@material-ui/core';
import { Link, NavLink, useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Routes from '../../Utils/routes.json';
import { hasChildren } from './hasChilder';
import CustomMenuItem from './CustomMenuItem';
import NestedMenuItem from './NestedMenuItem';
// ICONS
import { HiAcademicCap } from 'react-icons/hi';
import { IoIosPeople } from 'react-icons/io';
import { RiUserSettingsLine } from 'react-icons/ri';
import { MdOutlineGrading } from 'react-icons/md';
import PostAddRoundedIcon from '@material-ui/icons/PostAddRounded';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import LibraryAddRoundedIcon from '@material-ui/icons/LibraryAddRounded';
import ViewListRoundedIcon from '@material-ui/icons/ViewListRounded';
import PeopleAlt from '@material-ui/icons/PeopleAlt';
import DashboardIcon from '@material-ui/icons/Dashboard';
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer';
import PieChartRoundedIcon from '@material-ui/icons/PieChartRounded';
import EventNoteIcon from '@material-ui/icons/EventNote';
import SubjectIcon from '@material-ui/icons/Subject';
import AssignmentIcon from '@material-ui/icons/Assignment';
import ThumbsUpDownIcon from '@material-ui/icons/ThumbsUpDown';
import FlipCameraAndroidIcon from '@material-ui/icons/FlipCameraAndroid';
import PeopleIcon from '@material-ui/icons/People';
import ArrowBackOutlinedIcon from '@material-ui/icons/ArrowBackOutlined';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
const drawerWidth = 260;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  sidenavMain: {
    background: '#fff',
  },
  root1: {
    display: 'flex',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  drawer: {
    width: drawerWidth,
    [theme.breakpoints.up('md')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
    width: drawerWidth,
    whiteSpace: 'nowrap',
    background: `#fff`,
    backgroundRepeat: 'round',
    '& .MuiDrawer-paper': {
      overflowY: 'hidden',
    },

  },
  drawerPaper: {
    width: drawerWidth,
    zIndex: 99999,
    [theme.breakpoints.up('md')]: {
      width: drawerWidth,
      zIndex: 1,
      paddingTop: 105,
    },
  },
  displayDrawer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '91vh',
    overflowY: 'auto',
    overflowX: 'hidden',
    zIndex: 0,
    paddingTop: '15px',
    '&::-webkit-scrollbar': {
      width: '0px',
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: `inset 0 0 6px #d1d1d1`,
      webkitBoxShadow: `inset 0 0 6px #d1d1d1`,
      backgroundColor: `inset 0 0 6px #d1d1d1`,
      opacity: '0.2',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: `inset 0 0 6px #d1d1d1`,
      opacity: '0.1',
      outline: `1px solid ${theme.palette.KenColors.neutral100}`,
    },
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    marginTop: 16,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    // color: '#FBB601',
    background: 'transparent',
    width: 50,
    height: 50,
  },
  hide: {
    display: 'none',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: theme.spacing(2, 0, 0, 2),
    padding: theme.spacing(0, 2, 2, 2),
  },
  poweredBy: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '24px 10px',
  },
  logo: {
    height: '60px',
  },
  title: {
    fontSize: '10px',
    margin: theme.spacing(0, 2),
    color: theme.palette.KenColors.kenWhite,
    textAlign: 'end',
  },
  resources: {
    padding: 0,
  },
  subLevel: {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '12px',
    color: theme.palette.KenColors.kenWhite,
    height: 'auto',
  },
  link: {
    textDecoration: 'none',
    color: 'black  ',
    marginTop: "16px",
    '&:hover': {
      color: '#FFB100',
      textDecoration: 'none',
      '& path ': {
        fill: '#FFB100 !important',
      }
    },
  },
  userName: {
    marginTop: 20,
    fontSize: 20,
    color: theme.palette.KenColors.kenWhite,
  },
  studentClassItem: {
    marginTop: 20,
    fontSize: 14,
    color: theme.palette.KenColors.kenWhite,
  },
  heading: {
    marginLeft: 24,
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '0.875rem',
    lineHeight: '20px',
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.KenColors.kenWhite,
  },
  subHeading: {
    marginLeft: 32,
    fontSize: '0.875rem',
    color: theme.palette.KenColors.kenWhite,
  },
  contentDisabled: {
    // cursor: "not-allowed",
    textDecoration: 'none',
    pointerEvents: 'none',
  },

  subListItem: {
    // marginLeft: 4,
    '&:hover': {
      backgroundColor: theme.palette.KenColors.sideNavItemHoverBackground,
      '& $subLevel': {
        color: theme.palette.KenColors.sideNavItemHoverColor,
      },
      '& $heading': {
        color: theme.palette.KenColors.sideNavItemHoverColor,
      },
    },
    '&.Mui-selected': {
      // backgroundColor: theme.palette.KenColors.sideNavItemActiveBackground,
      backgroundColor: '#000',
      color: 'white',
      fontWeight: 600,
    },
  },
  listItem: {
    padding: '8px 20px',
    // marginLeft: 4,
    '&:hover': {
      backgroundColor: theme.palette.KenColors.sideNavItemHoverBackground,
      '& $subLevel': {
        color: theme.palette.KenColors.sideNavItemHoverColor,
      },
      '& $heading': {
        color: theme.palette.KenColors.sideNavItemHoverColor,
      },
    },
    '&.Mui-selected': {
      backgroundColor: 'turquoise',
      color: 'white',
      fontWeight: 600,
    },
  },
  listItemSubLevel: {
    height: 'auto',
  },
  divider: {
    background: theme.palette.KenColors.background,
    height: 2,
  },
  active: {
    '& ListItem': {
      // borderLeft: `4px solid ${theme.palette.KenColors.kenWhite}`,
      color: '#FFB100'
    },

    '& $subListItem': {
      // borderLeft: `4px solid ${theme.palette.KenColors.kenWhite}`,
      marginLeft: 0,
      backgroundColor: theme.palette.KenColors.sideNavItemActiveBackground,
    },

    '& $heading': {
      color: theme.palette.KenColors.sideNavItemActiveColor,
    },
    '& $subLevel': {
      color: theme.palette.KenColors.sideNavItemActiveColor,
    },
    '&.Mui-selected': {
      color: '#FFB100',
      fontWeight: 600,
      '&:hover': {
        backgroundColor: theme.palette.KenColors.sideNavItemActiveBackground,
        // color: 'white',
      },
    },
  },
  FS: {
    color: theme.palette.KenColors.neutral100,
    fontSize: '14px',
    marginLeft: '32px',
  },
  gradeIcon: {
    color: theme.palette.KenColors.neutral100,
  },
  displayPic: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  name: {
    fontSize: '14px',
    color: theme.palette.KenColors.primary,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    background: '#fff',
    backgroundRepeat: 'round',
    borderRight: '2px solid #FFB100'
  },
  drawerOpen: {
    // background: theme.palette.KenColors.primary,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    zIndex: 0,
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginTop: 16,
    // background: theme.palette.KenColors.primary,
    overflowX: 'hidden',
    zIndex: 1100,
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(8) + 1,
      // width: 0,
      border: 'none',
    },
  },
  closeIcon: {
    cursor: 'pointer',
  },
  topContainer: {
    marginTop: 16,
    padding: '8px 16px',
  },
  dialogPaper: {
    height: 'none',
  },
  dialogTitle: {
    color: theme.palette.KenColors.kenBlack,
  },
  dialogAgree: {
    fontSize: 12,
  },
  popover: {
    // marginTop: '-25px',
    backgroundColor: '#121b2f',
  },
  header: {
    padding: '8px 16px',
    color: theme.palette.KenColors.kenWhite,
    fontSize: '14px',
    fontWeight: 600,
  },
  subMenu: {
    paddingLeft: 36,
  },
  menuIcon: {
    color: '#000',
    marginRight: '10px',
    minWidth: 0,
    fontSize: 24,
  },
  menuIco: {
    '&:hover': {
      color: '#000 !important',
    },
  },
  subMenuText: {
    fontSize: '0.725rem',
    wordBreak: 'break-word',
    whiteSpace: 'normal',
    color: '#000',
  },
  menuItemText: {
    fontSize: '16px',
    color: '#000',
    // fontFamily: 'lato,Work Sans, sans-serif',
  },
  logoWrap: {
    width: 170,
    display: 'inline-block',
  },
  active1: {
    color: '#FFB100 !important',
    '& path ': {
      fill: '#FFB100 !important',
    }
  },
  activeIcon: {
    color: '#FFB100'
  },

}));

const SideNavigation = (props) => {
  const classes = useStyles();
  const menus = [
    {
      id: 6,
      icon: (
        <RiUserSettingsLine />
      ),
      label: 'Exam Management',
      callback: null,
      isParent: true,
      isSubSubMenu: false,
      items: [
        {
          icon: (
            <DashboardIcon />
          ),
          label: 'Dashboard',
          path: Routes.examDashboard,
          isParent: false,
          isSubSubMenu: true,
          callback: null,
        },
        {
          icon: (
            <DashboardIcon />
          ),
          label: 'Exam Setup',
          path: Routes.ExamSetup,
          isParent: false,
          isSubSubMenu: true,
          callback: null,
        },
        {
          icon: (<QuestionAnswerIcon />),
          label: 'Question Paper',
          path: Routes.questionPapers,
          isParent: false,
          isSubSubMenu: true,
          callback: null,
        },
        {
          icon: (<PeopleIcon />),
          label: 'Student Status',
          path: Routes.studentStatus,
          isParent: false,
          isSubSubMenu: true,
          callback: null,
        },
        {
          icon: (<SubjectIcon />

          ),
          label: 'Invigilation & Proctoring',
          path: Routes.invigilationProctoring,
          isParent: false,
          isSubSubMenu: true,
          callback: null,
        },
        {
          icon: (

            <AssignmentIcon />

          ),
          label: 'Evaluation',
          path: Routes.evaluation,
          isParent: false,
          isSubSubMenu: true,
          callback: null,
        },
        {
          icon: (

            <PieChartRoundedIcon />

          ),
          label: 'Grading',
          path: Routes.grading,
          isParent: false,
          isSubSubMenu: true,
          callback: null,
        },
        {
          icon: (

            <FlipCameraAndroidIcon />

          ),
          label: 'Requests',
          path: Routes.requests,
          isParent: false,
          isSubSubMenu: true,
          callback: null,
        },
      ],
    },
  ];
  const { openDrawer, setOpenDrawer, mobileScreen, setHeading } = props;
  const [menuItem, setMenuItem] = React.useState(menus);
  const [menuPosition, setMenuPosition] = React.useState(null);
  const history = useHistory();
  const location = useLocation();
  const url = location.pathname.split("/");

  const { t } = useTranslation();


  const styles = (path) => {
    const paths = path.split("/")
    const reqUrl = url[3]?.toLocaleLowerCase()
    if (paths[3] === reqUrl) {
      return true
    } else {
      return false
    }

   
  };

  const logout = () => {
    localStorage.clear();
    localStorage.removeItem('loggedIn');
    history.push('/login');
  };
  const handleDrawerClose = () => {
    setOpenDrawer(false);
  };
  const handleDrawerOpen = () => {
    setOpenDrawer(true);
  };
  const handleItemClick = (event) => {
    setMenuPosition(null);
  };
  const MenuItem = ({ item, openDrawer, setOpen }) => {
    const Component = hasChildren(item) ? MultiLevel : SingleLevel;
    return <Component openDrawer={openDrawer} setOpen={setOpen} item={item} />;
  };
  const SingleLevel = ({ item, openDrawer }) => {
    const classes = useStyles();
    return (
      <>
        <NavLink
          className={classes.link}
          to={item?.path || ''}
          activeClassName={`${classes.active1}`}
          exact
          isActive={() => styles(`${item.path}`.toLowerCase())}
          onClick={
            mobileScreen
              ? () => {
                handleDrawerClose();
                setHeading(item.label);
              }
              : () => {
                if (item?.callback !== null) {
                  window.open(item.callback, '_blank');
                }
                setHeading(item.label);
                handleDrawerOpen();
              }
          }
        >
          <ListItem button style={{ padding: openDrawer === false ? '12px 20px' : item.isSubSubMenu ? '12px 0px 12px 32px' : '12px 24px', }} >
            <ListItemIcon >
              {item.icon}
            </ListItemIcon>
            {openDrawer === true && (
              <div style={{ paddingLeft: '10px' }}>
                <ListItemText
                  primary={item.label}
                />
              </div>)}

          </ListItem>

          {/* <ListItem
              className={
                item.isSubSubMenu ? classes.subListItem : classes.listItem
              }
              style={{
                padding:
                  openDrawer === false
                    ? '12px 20px'
                    : item.isSubSubMenu
                      ? '12px 0px 12px 56px'
                      : '12px 24px',
              }}
              button
            >
              <ListItemIcon className={classes.menuIcon}>
                {item.icon}
              </ListItemIcon>

              {openDrawer === true && (
                <ListItemText
                  primaryTypographyProps={{
                    className: item.isSubSubMenu
                      ? classes.subMenuText
                      : classes.menuItemText,
                  }}
                  primary={item.label}
                />
              )}
            </ListItem> */}

        </NavLink >
      </>
    );
  };
  const MultiLevel = ({ item, key, openDrawer }) => {
    const classes = useStyles();
    const { items: children } = item;
    const [open, setOpen] = useState(false);

    const handleClick = () => {
      if (openDrawer === false) {
        return;
      }
      setOpen((prev) => !prev);
    };
    useEffect(() => {
      if (openDrawer === false) {
        setOpen(false);
      }
    }, [openDrawer]);

    return (
      <React.Fragment>
        <ListItem
          button
          style={{ paddingLeft: openDrawer === true ? 0 : 0 }}
          onClick={(e) => handleClick(openDrawer)}
        >
          {openDrawer === true && (
            <ListItem button >
              <ListItemIcon className={classes.menuIcon}>
                {item.icon}
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{ className: classes.menuItemText }}
                primary={item.label}
              />
              <div style={{ marginTop: '5px' }}>
                {open ? (
                  <ExpandLessIcon style={{ color: '#fff' }} />
                ) : (
                  <ExpandMoreIcon style={{ color: '#fff' }} />
                )}
              </div>
            </ListItem>
          )}

        </ListItem>
        <List
          style={{ color: '#000', marginTop: openDrawer === false && '-16px' }}
          disablePadding
        >
          {children?.map((child, key) => (
            <MenuItem openDrawer={openDrawer} key={key} item={child} />
          ))}
        </List>
        {/* <Collapse in={open} timeout="auto" unmountOnExit /> */}
      </React.Fragment>
    );
  };
  const customRender = (items) => {
    if (!Array.isArray(items)) return <></>;
    return items?.map((item, index) => {
      if (item.items) {
        return (
          <NestedMenuItem
            label={item.label}
            parentMenuOpen={!!menuPosition}
            PaperProps={{ className: classes.popover }}
            icon={item.icon}
            index={index}
            header={item.label}
          >
            {customRender(item.items)}
          </NestedMenuItem>
        );
      }
      return item?.path ? (
        <NavLink
          key={index}
          className={classes.link}
          to={item?.path}
          activeClassName={classes.activeLinkInner}
          exact
          onClick={mobileScreen ? handleDrawerClose : handleDrawerOpen}
        >
          <CustomMenuItem
            key={index}
            onClick={handleItemClick}
            icon={item.icon}
            label={item.label}
            openDrawer={openDrawer}
          />
        </NavLink>
      ) : (
        <CustomMenuItem
          key={index}
          onClick={handleItemClick}
          icon={item.icon}
          label={item.label}
          openDrawer={openDrawer}
          className={classes.navIcon}
        />
      );
    });
  };
  return (
    <div className={classes.root}>
      <div className={classes.sidenavMain}>
        <Drawer
          variant={props.variant}
          onClose={() => {
            props.drawerChanges();
          }}
          open={props.openDrawer}
          container={props.container}
          anchor={props.anchor}
          ModalProps={{
            keepMounted: props.ModalProps,
          }}
          classes={{
            paper: clsx(classes.drawer, {
              [classes.drawerOpen]: openDrawer,
              [classes.drawerClose]: !openDrawer,
            }),
          }}
          className={clsx(classes.drawer, {
            [classes.drawerOpen]: openDrawer,
            [classes.drawerClose]: !openDrawer,
          })}
        >
          <Box className={classes.topContainer}>
            {openDrawer ? (
              <>
                <Grid container spacing={1}>
                  <Grid item md={12} style={{ textAlign: 'right' }}>
                    <IconButton
                      color="inherit"
                      aria-label="open drawer"
                      edge="start"
                      className={classes.menuButton}
                    >
                      {/* <img
                        onClick={handleDrawerClose}
                        className={classes.closeIcon}
                        src={
                          'https://inazstgpfs3001.blob.core.windows.net/assets/sp-jain/admin/svgs/collapse.svg'
                        }
                      /> */}
                      <p
                        onClick={handleDrawerClose}
                        className={classes.closeIcon}
                      >
                        &#171;
                      </p>
                    </IconButton>
                  </Grid>
                  {/* <Grid item md={12}>
                    <NavLink
                      className={classes?.logoWrap}
                      to={`/${Routes.addProgram}`}
                    >
                      <img
                        style={{ float: 'left' }}
                        src={
                          'https://inazstgpfs3001.blob.core.windows.net/assets/ken42_logo.png'
                        }
                        // src={
                        //   'https://inazstgpfs3001.blob.core.windows.net/assets/sp-jain/admin/Images/spJainTitle.png'
                        // }
                        className={classes.logo}
                      />
                    </NavLink>
                  </Grid> */}
                </Grid>
              </>
            ) : (
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerOpen}
                edge="start"
              >
                <img
                  onClick={handleDrawerClose}
                  className={classes.closeIcon}
                  src={
                    'https://inazstgpfs3001.blob.core.windows.net/assets/sp-jain/pfs-portal/icons/DoubleChevronRight.svg'
                  }
                />
              </IconButton>
            )}
          </Box>
          <div className={classes.displayDrawer}>
            <Grid>
              {menuItem?.map((item, key) => {
                return (
                  <List
                    className={!item.isParent ? 'submenu-submenu-padding' : ''}
                    component="div"
                    activeClassName={classes.activeLinkInner}
                    disablePadding
                  >
                    <MenuItem key={key} openDrawer={openDrawer} item={item} />
                  </List>
                );
              })}
              <Hidden mdUp>
                <Link className={classes.link}>
                  <ListItem
                    className={classes.listItem}
                    button
                    key="signOut"
                    onClick={logout}
                  >
                    <span>
                      <ArrowBackOutlinedIcon />
                    </span>
                    <span className={classes.heading}>Signout</span>
                  </ListItem>
                </Link>
              </Hidden>
            </Grid>
          </div>
        </Drawer>
      </div>
    </div>
  );
};

export default SideNavigation;
